import { Injectable } from '@angular/core';
import  *  as CryptoJS from  'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

	cryptoKey: string = 'legacy-2025-app';
	storageKey: any = 'lcs25';

    constructor(
	) {
    }

  	removeFromStorage(param: string): void {
		let ref = this.storageKey + '_' + param;
		window.localStorage.removeItem(ref);
	}

	async getFromStorage(param: string) {
		let ref = this.storageKey + '_' + param;
		let item = window.localStorage.getItem(ref);
		let decryptedItem = item !== null ? this.decrypt(item) : null;
		return decryptedItem !== null ? JSON.parse(decryptedItem) : null;
	}

	sendToStorage(param: string, data: any) {
		let ref = this.storageKey + '_' + param;
		window.localStorage.setItem(ref, this.encrypt(JSON.stringify(data)));
	}

	private encrypt(txt: string): string {
		return CryptoJS.AES.encrypt(txt, this.cryptoKey).toString();
	}

	private decrypt(txtToDecrypt: string) {
		return CryptoJS.AES.decrypt(txtToDecrypt, this.cryptoKey).toString(CryptoJS.enc.Utf8);
	}

}
